const usePandaDispatcher = (key) => {
  const dispatchEvent = (data = {}, keyOverride = '') => {
    window.dispatchEvent(
      new CustomEvent('panda-event-in-remote', {
        detail: {
          key: keyOverride || key,
          payload: {
            ...data,
          },
        },
      }),
    );
  };

  return {
    dispatchEvent,
  };
};

export default usePandaDispatcher;
